// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:base-models --tenant projectReplica` to regenerate.
import DatabaseRecord from "velocious/build/src/database/record/index.js"

/**
 * Attributes accepted when creating or updating Sync records.
 * @typedef {object} SyncWriteAttributes
 * @property {string} [id] - Value for the id attribute.
 * @property {string} [resourceType] - Value for the resourceType attribute.
 * @property {string} [resourceId] - Value for the resourceId attribute.
 * @property {string} [syncType] - Value for the syncType attribute.
 * @property {string | null} [command] - Value for the command attribute.
 * @property {Record<string, unknown>} [data] - Value for the data attribute.
 * @property {Record<string, unknown> | null} [baseVersion] - Value for the baseVersion attribute.
 * @property {string | null} [predecessorMutationId] - Value for the predecessorMutationId attribute.
 * @property {number} [sequence] - Value for the sequence attribute.
 * @property {string} [state] - Value for the state attribute.
 * @property {string | null} [failureReason] - Value for the failureReason attribute.
 * @property {Record<string, unknown> | null} [failureDetails] - Value for the failureDetails attribute.
 * @property {Date | string} [createdAt] - Value for the createdAt attribute.
 * @property {Date | string} [updatedAt] - Value for the updatedAt attribute.
 */

/** @augments {DatabaseRecord<SyncWriteAttributes>} */
export default class SyncBase extends DatabaseRecord {
  /** @returns {typeof import("../models/sync.js").default} */
  // @ts-ignore - override narrows return type for better IntelliSense in generated model bases
  getModelClass() { return /** @type {typeof import("../models/sync.js").default} */ (this.constructor) }

  /** @returns {string} */
  id() { return this.readAttribute("id") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setId(newValue) { return this._setColumnAttribute("id", newValue) }

  /** @returns {boolean} */
  hasId() { return this._hasAttribute(this.id()) }

  /** @returns {string} */
  resourceType() { return this.readAttribute("resourceType") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setResourceType(newValue) { return this._setColumnAttribute("resourceType", newValue) }

  /** @returns {boolean} */
  hasResourceType() { return this._hasAttribute(this.resourceType()) }

  /** @returns {string} */
  resourceId() { return this.readAttribute("resourceId") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setResourceId(newValue) { return this._setColumnAttribute("resourceId", newValue) }

  /** @returns {boolean} */
  hasResourceId() { return this._hasAttribute(this.resourceId()) }

  /** @returns {string} */
  syncType() { return this.readAttribute("syncType") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setSyncType(newValue) { return this._setColumnAttribute("syncType", newValue) }

  /** @returns {boolean} */
  hasSyncType() { return this._hasAttribute(this.syncType()) }

  /** @returns {string | null} */
  command() { return this.readAttribute("command") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setCommand(newValue) { return this._setColumnAttribute("command", newValue) }

  /** @returns {boolean} */
  hasCommand() { return this._hasAttribute(this.command()) }

  /** @returns {Record<string, unknown>} */
  data() { return this.readAttribute("data") }

  /**
   * @param {Record<string, unknown>} newValue
   * @returns {void}
   */
  setData(newValue) { return this._setColumnAttribute("data", newValue) }

  /** @returns {boolean} */
  hasData() { return this._hasAttribute(this.data()) }

  /** @returns {Record<string, unknown> | null} */
  baseVersion() { return this.readAttribute("baseVersion") }

  /**
   * @param {Record<string, unknown> | null} newValue
   * @returns {void}
   */
  setBaseVersion(newValue) { return this._setColumnAttribute("baseVersion", newValue) }

  /** @returns {boolean} */
  hasBaseVersion() { return this._hasAttribute(this.baseVersion()) }

  /** @returns {string | null} */
  predecessorMutationId() { return this.readAttribute("predecessorMutationId") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setPredecessorMutationId(newValue) { return this._setColumnAttribute("predecessorMutationId", newValue) }

  /** @returns {boolean} */
  hasPredecessorMutationId() { return this._hasAttribute(this.predecessorMutationId()) }

  /** @returns {number} */
  sequence() { return this.readAttribute("sequence") }

  /**
   * @param {number} newValue
   * @returns {void}
   */
  setSequence(newValue) { return this._setColumnAttribute("sequence", newValue) }

  /** @returns {boolean} */
  hasSequence() { return this._hasAttribute(this.sequence()) }

  /** @returns {string} */
  state() { return this.readAttribute("state") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setState(newValue) { return this._setColumnAttribute("state", newValue) }

  /** @returns {boolean} */
  hasState() { return this._hasAttribute(this.state()) }

  /** @returns {string | null} */
  failureReason() { return this.readAttribute("failureReason") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setFailureReason(newValue) { return this._setColumnAttribute("failureReason", newValue) }

  /** @returns {boolean} */
  hasFailureReason() { return this._hasAttribute(this.failureReason()) }

  /** @returns {Record<string, unknown> | null} */
  failureDetails() { return this.readAttribute("failureDetails") }

  /**
   * @param {Record<string, unknown> | null} newValue
   * @returns {void}
   */
  setFailureDetails(newValue) { return this._setColumnAttribute("failureDetails", newValue) }

  /** @returns {boolean} */
  hasFailureDetails() { return this._hasAttribute(this.failureDetails()) }

  /** @returns {Date} */
  createdAt() { return this.readAttribute("createdAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setCreatedAt(newValue) { return this._setColumnAttribute("createdAt", newValue) }

  /** @returns {boolean} */
  hasCreatedAt() { return this._hasAttribute(this.createdAt()) }

  /** @returns {Date} */
  updatedAt() { return this.readAttribute("updatedAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setUpdatedAt(newValue) { return this._setColumnAttribute("updatedAt", newValue) }

  /** @returns {boolean} */
  hasUpdatedAt() { return this._hasAttribute(this.updatedAt()) }

  /**
   * @returns {import("velocious/build/src/database/record/index.js").default}
   */
  resource() { return /** @type {import("velocious/build/src/database/record/index.js").default} */ (this.getRelationshipByName("resource").loaded()) }

  /**
   * @abstract
   * @param {ConstructorParameters<typeof import("velocious/build/src/database/record/index.js").default>[0]} [attributes]
   * @returns {import("velocious/build/src/database/record/index.js").default}
   */
  buildResource(attributes) { void attributes; throw new Error("Not implemented") }

  /**
   * @abstract
   * @returns {Promise<import("velocious/build/src/database/record/index.js").default | undefined>}
   */
  loadResource() { throw new Error("Not implemented") }

  /**
   * @returns {Promise<import("velocious/build/src/database/record/index.js").default | undefined>}
   */
  resourceOrLoad() { return /** @type {Promise<import("velocious/build/src/database/record/index.js").default | undefined>} */ (this.relationshipOrLoad("resource")) }

  /**
   * @abstract
   * @param {import("velocious/build/src/database/record/index.js").default} newModel
   * @returns {void}
   */
  setResource(newModel) { void newModel; throw new Error("Not implemented") }
}
